import React, { useEffect } from 'react';
import { NavLink as Link } from 'react-router-dom';
import styled from 'styled-components';
import { CatData } from '../../../../catdata';

import useFetch from '../../../../hook/useFetch'

import { useDispatch, useSelector } from 'react-redux'

import { getLandingPage } from '../../../../pages/features/landingpage/landingpageSlice'


import { Category } from '../../../../components/category';

const PopularCatSection = () => {

    const dispatch = useDispatch()

    
    const { resourceCategory, resourceCategoryStatus} = useSelector(state => state.resourceCategory);
    const { landingPage} = useSelector(state => state?.landingPage)

    useFetch(getLandingPage);

    // useEffect(() => {

    //     dispatch(getResourceCategory());

    // }, [resourceCategoryStatus]);


  return (
    <Container>
        <HeaderContainer>
            <h2>Nigeriana</h2>
            <h5> <NavLink to='/nigeriana-categories' >View all</NavLink> </h5>
        </HeaderContainer>

        <CardContainer>

            {
                landingPage?.systemInternalResourceCategories?.slice(0, 8).map((category) => {
                    return (
                        <CatContainer key={category.resourceCategoryId}>
                            <CatLink href={`/nigeriana/category/${category.resourceCategoryId} `}>
                                {category?.resourceCategoryName}
                            </CatLink>
                        </CatContainer>
                            
                    )
                })
            }

        </CardContainer>
    </Container>
  )
}


export const Container = styled.div`
    width: 100%;
    max-width: 1250px;
    display: flex;
    margin: 0 auto;
    padding: 24px 0;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    @media screen and (max-width: 600px){
            width: 90%;
        }
`;

export const HeaderContainer = styled.div`
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    flex-direction: row;

    & > h2{

        @media screen and (max-width: 600px){
            font-size: 1.8rem;
            font-weight: 500;
        }
    }

    & > h3{

        @media screen and (max-width: 600px){
            font-size: 1.5rem;
            font-weight: 500;
        }
    }

    & > h5{
        color: #2A870E;
        font-size: 20px;
        font-weight: 400;

        @media screen and (max-width: 600px){
            font-size: 1.2rem;
            /* font-weight: 500; */
        }
    }
`;

export const NavLink = styled(Link)`
    color: #2A870E;
    font-size: 19px;
    font-weight: 400;

    &:hover{
        opacity: 0.7;
        transition: 0.5s ease-in-out; ;
    }

    @media screen and (max-width: 600px){
            font-size: 1.4rem;
            /* font-weight: 500; */
        }
`;

const CardContainer = styled.div`
    width: 100% !important;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    gap: 2rem;
    column-gap: 2rem;
    justify-content: space-between;
    /* border: 1px solid red; */

    @media screen and (max-width: 600px){
            display: flex;
            flex-direction: column;
            align-items: center;
            /* font-weight: 500; */
        }
`;


const CatContainer = styled.div`
    width: 100% !important;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    gap: 2rem;
    column-gap: 2rem;
    justify-content: space-between;

    @media screen and (max-width: 600px){
            display: flex;
            flex-direction: column;
            align-items: center;
            /* font-weight: 500; */
        }
`;

const CatLink = styled.a`
    padding: 28px 0px;
    width: 250px !important;
    background: #FFFFFF;
    box-shadow: 0px 4px 4px rgba(255, 255, 255, 0.25), 0px 4px 4px rgba(0, 0, 0, 0.15);
    border-radius: 4px;
    font-size: 15px;
    font-weight: 600;
    text-align: center;
    /* width: fit-content; */
    color: #101828;

    &:hover{
        transition: all .3s ease-out;
        color: #727171;
    }
`


export {PopularCatSection}